import { MuiAccordion, strIsNullOrEmpty, StyledAccordionSummary } from '@fox/atoms';
import { sanitize } from 'dompurify';
import { useState } from 'react';
import styled from 'styled-components';
import { useComponentClassContext } from '../../component-class-context';
import { useComponentStyleContext } from '../../component-style-context';

type CollapseModel = {
	expandByDefault?: boolean;
	collapses: { title: string; mainContent: string }[];
};
interface ISingleAccordionProps {
	collapseModel: CollapseModel;
	headerBackgroundColour?: string;
}

const AccordionStyleWrapper = styled.div`
	.MuiAccordionDetails-root {
		padding: 0px;
	}
`;

export function SingleAccordion({ collapseModel, headerBackgroundColour }: ISingleAccordionProps) {
	const {
		backgroundColour,
		font,
		fontColour,
		fontSizeRem,
		fontTextShadow,
		headerFont,
		headerFontColour,
		textAlignment,
		headerTextShadow
	} = useComponentStyleContext();
	const { headerClass } = useComponentClassContext();
	const [expanded, setExpanded] = useState<string | false>(false);

	return (
		<AccordionStyleWrapper>
			{collapseModel.collapses?.map((collapse, i) => {
				return (
					<MuiAccordion
						key={i}
						expanded={expanded === `panel_${i}`}
						onChange={(_, isExpanded: boolean) => {
							setExpanded(isExpanded ? `panel_${i}` : false);
						}}
						disableGutters={true}
						elevation={0}
						sx={{
							...(!strIsNullOrEmpty(headerBackgroundColour) ? { background: headerBackgroundColour } : backgroundColour),
							borderRadius: 0
						}}
						square={true}
						defaultExpanded={collapseModel.expandByDefault === true ? i === 0 : false}
					>
						<StyledAccordionSummary
							sx={{ border: '1px solid rgba(0, 0, 0, .125)' }}
							title={
								strIsNullOrEmpty(collapse.title) ? (
									<></>
								) : (
									<div
										style={{
											paddingLeft: '1rem',
											paddingRight: '1rem',
											...headerFont,
											...headerFontColour,
											...textAlignment,
											...headerTextShadow,
											width: '100%'
										}}
										className={headerClass}
										dangerouslySetInnerHTML={{ __html: sanitize(collapse.title) }}
									/>
								)
							}
						/>
						{strIsNullOrEmpty(collapse.mainContent) ? (
							<></>
						) : (
							<div
								style={{
									padding: '1rem',
									...backgroundColour,
									...font,
									...fontColour,
									...fontSizeRem,
									...fontTextShadow,
									...textAlignment
								}}
								dangerouslySetInnerHTML={{ __html: sanitize(collapse.mainContent) }}
							/>
						)}
					</MuiAccordion>
				);
			})}
		</AccordionStyleWrapper>
	);
}
